import Button from "@app/components/move2Library/Button/Button"
import Input from "@app/components/move2Library/Input/Input"
import { useRaiseError } from "@app/store/actions/errorActions"
import { useGetStrings } from "@app/store/service/cmsService"
import { useResetPassword } from "@app/store/service/connectorService"
import { emailPattern } from "@app/utils/validations"
import { useToasts } from "@tecreation/funnel-components"
import { useForm } from "react-hook-form"
const ForgotPassword = ({ onSuccess }) => {
	const raiseError = useRaiseError()
	const { addToast } = useToasts()
	const {
		data: {
			buttonSend,
			myParadiseForgotPasswordMessageTitle,
			myParadiseForgotPasswordMessageBody,
			placeholderEMail,
			errorInputMissingEmail,
			errorInputInvalidEmail,
		},
	} = useGetStrings(undefined, { defaultData: {} })
	const {
		register,
		formState: { errors },
		handleSubmit,
	} = useForm({
		defaultValues: {
			resetEmail: "",
			activateEmail: "",
		},
	})

	const [resetPassword] = useResetPassword()

	const resetPasswordClick = async () => {
		handleSubmit(async data => {
			try {
				await resetPassword({ email: data.resetEmail }).unwrap()
				addToast({
					variant: "success",
					title: myParadiseForgotPasswordMessageTitle,
					body: myParadiseForgotPasswordMessageBody,
				})
				onSuccess()
			} catch (e) {
				raiseError(e)
			}
		})()
	}
	return (
		<div>
			<div className="mb-5">
				<div className="mb-4">Geben Sie Ihre E-Mail Adresse ein, um Ihr Kennwort zurückzusetzen.</div>
				<Input
					type="text"
					formRegister={register("resetEmail", {
						required: {
							value: true,
							message: errorInputMissingEmail,
						},
						pattern: {
							value: emailPattern,
							message: errorInputInvalidEmail,
						},
					})}
					errors={errors}
					label={placeholderEMail + "*"}
				/>
				<div className="mt-3">
					<Button onClick={resetPasswordClick} style="secondary">
						{buttonSend}
					</Button>
				</div>
			</div>
			{/* <div>
                <div className="mb-4">
                Falls Sie bisher ihr Konto noch nicht aktiviert haben, geben Sie bitte ebenfalls Ihre E-mail Adresse an und klicken dann auf "Konto aktivieren".
                </div>
                <Input
                    type={"text"}
                    formRegister={register("activateEmail", {
                        required: {
                            value: true,
                            message: errorInputMissingEmail,
                        },
                        pattern: {
                            value: emailPattern,
                            message: errorInputInvalidEmail,
                        },
                    })}
                    errors={errors}
                    label={placeholderEMail + "*"}
                />
                <div className="mt-3 mb-5">
                    <Button onClick={resetPassword} style="secondary">
                        {buttonActivateAccount}
                    </Button>
                </div>
            </div> */}
		</div>
	)
}

export default ForgotPassword
